import { render } from "./SignatureComp.vue?vue&type=template&id=fe141300&scoped=true"
import script from "./SignatureComp.vue?vue&type=script&lang=js"
export * from "./SignatureComp.vue?vue&type=script&lang=js"

import "./SignatureComp.vue?vue&type=style&index=0&id=fe141300&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fe141300"]])

export default __exports__